<template>
  <activity-intro
    :message="data.introductionDescription"
    @onNextView="onNextView"
    start-audio-id="start-activity"
    background-image-id="bg-title-screen"
    btn-play-bg-color="green-100"
    btn-play-color-icon="black-100"
    :text-title="data.introductionTitle"
    :src-voice-over="require('@/assets/audios/vo/vo-splash-screen.mp3')"
  >
    <template v-slot:introduction-actions>
      <zoom-button
        bg-color-controls="white"
        bg-color-zoom-button="purple-200"
        controls-icon-color-default="green-100"
        controls-icon-color-hover="green-100"
        zoom-icon-color-active="white"
        zoom-icon-color-default="black-300"
        zoom-icon-color-hover="green-100"
        zoom-reset-color="green-100"
        zoom-value-color="black-100"
      />
      <fullscreen-button
        icon-variant-hover="green-100"
        icon-variant="#414043"
      />
    </template>

    <card-modal ref="cardModal"></card-modal>
  </activity-intro>
</template>

<script>
import { ref } from '@vue/composition-api';
import {
  ActivityIntro,
  ZoomButton,
  FullscreenButton,
} from '@discoveryeducation/components';
import { CardModal } from '../components/modals';

export default {
  name: 'IntroPage',
  components: { CardModal, ActivityIntro, ZoomButton, FullscreenButton },
  setup() {
    const cardModal = ref(null);

    const onNextView = () => {
      cardModal.value.showModal();
    };

    return { onNextView, cardModal };
  },
};
</script>

<style lang="stylus" scoped>

color-black-100 = colors.black-100
color-black-300 = colors.black-300
color-black-400 = colors.black-400
color-green-200 = colors.green-200
color-purple-100 = colors.purple-100

.activity-intro
  background-color colors.white

&::v-deep
  .button--play-audio
    border-radius radius-audio
    width 45px
    height 45px
    margin-right 3px
    &:hover
      background-color color-green-200

  .zoom-button.zoom-main-icon
    font-size 26px !important

  .zoom-controls
    border 1px solid color-purple-100

  .fullscreen-button
    font-size 14px
    margin-left 12px

  .activity-intro__intro-side
    padding 110px 84px 67px 70px

  .introduction-content
    &__title
      text-align left
      font-family Nunito-SemiBold
      font-size 40px
      line-height 54px
      color colors.black-100
      margin-top 35px
      margin-bottom 20px

    &__message
      text-align left
      font-size 24px
      line-height 35px
      color colors.black-400
      letter-spacing 0
      font-family Nunito-Light
      white-space pre-line
</style>
